<template>
	<div id="wrap">
		<div>
			<el-button type="primary" @click="handleAdd">添加</el-button>
			<el-button type="primary" @click="upload.open = true">批量导入</el-button>
		</div>

		<el-dialog
			title="资本化管理"
			:visible.sync="centerDialogVisible"
			width="30%"
			center
		>
			<div>
				<el-form
					label-width="120px"
					:model="formData"
					:rules="rules"
					ref="formData"
				>
					<el-form-item v-if="!type" prop="projectId" label="选择项目：">
						<el-select v-model="formData.projectId" placeholder="设备类型">
							<el-option
								v-for="dict in projectList"
								:key="dict.id"
								:label="dict.projectName"
								:value="dict.id"
								placeholder="请选择"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="annual" label="形成年度：">
						<el-date-picker
							v-model="formData.annual"
							type="year"
							value-format="yyyy"
							placeholder="选择年"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item prop="intangibleAssetName" label="名称：">
						<el-input v-model="formData.intangibleAssetName"></el-input>
					</el-form-item>
					<el-form-item prop="amortizationTotal" label="总摊销额：">
						<el-input
							v-model="formData.amortizationTotal"
							@blur="ntxe"
							onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
							><template slot="append">元</template></el-input
						>
					</el-form-item>
					<el-form-item prop="amortizationDuration" label="摊销时长：">
						<el-input
							v-model="formData.amortizationDuration"
							@blur="ntxe"
							onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
							><template slot="append">年</template></el-input
						>
					</el-form-item>
					<el-form-item label="年摊销额：">
						<el-input v-model="amortizationTotal" :disabled="true"
							><template slot="append">元</template></el-input
						>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">返回</el-button>
				<el-button type="primary" @click="classSubmitForm">保存</el-button>
			</span>
		</el-dialog>

		<!-- 导入 -->
		<el-dialog title="批量导入" :visible.sync="upload.open" center width="44%">
			<div class="dialog_content">
				<div class="download" style="margin-top: 20px;line-height: 25px">
					<div>填写需要导入的数据</div>
					<div style="color: #a3adb9">
						请按照数据模板的格式准备导入数据,模板中的表头名称不可更改,表头行不能删除,表格格式不能修改
					</div>
					<div>
						<el-link type="primary" :underline="false" @click="importTemplate"
							>下载模板</el-link
						>
					</div>
				</div>
				<div class="upload" style="margin-top: 20px;line-height: 25px">
					<div>上传填好的表格</div>
					<div style="color: #a3adb9">
						文件后缀名必须为xls或xsx (即Excel格式) ,文件大小不得大于5M
					</div>
					<el-upload
						class="upload-demo"
						ref="upload"
						:limit="1"
						accept=".xlsx, .xls"
						:action="upload.url"
						:disabled="upload.isUploading"
						:auto-upload="false"
						:data="{ projectId: projectId }"
						:on-progress="handleFileProgress"
						:on-success="handleFileSuccess"
						:on-exceed="handleFileExceed"
					>
						<el-link type="primary" :underline="false">上传文件</el-link>
					</el-upload>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="upload.open = false">取 消</el-button>
				<el-button type="primary" @click="submitFileForm">保存</el-button>
			</div>
		</el-dialog>

		<el-form :inline="true" class="from" ref="formQuery" :model="queryParams">
			<el-form-item label="">
				<el-date-picker
					v-model="queryParams.annual"
					type="year"
					value-format="yyyy"
					placeholder="选择年"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item class="item_btn">
				<el-button type="primary" @click="handleQuery">查询</el-button>
				<el-button type="primary" @click="resetQuery">重置</el-button>
			</el-form-item>
		</el-form>

		<el-table
			class="table"
			:data="datas"
			:header-cell-style="{ background: '#F5F7FA' }"
			v-loading="loading"
			:row-class-name="tableRowClassName"
		>
			<el-table-column label="形成年度" prop="annual"></el-table-column>
			<el-table-column prop="intangibleAssetName" label="名称">
			</el-table-column>
			<el-table-column
				prop="amortizationTotal"
				label="总摊销额"
			></el-table-column>
			<el-table-column
				label="摊销时长(年)"
				prop="amortizationDuration"
			></el-table-column>
			<el-table-column
				label="更新时间"
				prop="updateTime"
				show-overflow-tooltip
			></el-table-column>

			<el-table-column label="操作" width="100" fixed="right">
				<template slot-scope="scope">
					<el-button
						type="text"
						size="small"
						class="green"
						@click="handleUpdate(scope.row.id)"
						>编辑</el-button
					>
					<el-button
						type="text"
						size="small"
						class="red"
						@click="handleDelete(scope.row.id)"
						>删除</el-button
					>
				</template>
			</el-table-column>
		</el-table>
		<div class="flex flex-end">
			<el-pagination
				class="pagination"
				background
				v-show="total > 0"
				:total="total"
				:current-page.sync="queryParams.pageNum"
				:page-size.sync="queryParams.pageSize"
				@current-change="getList"
			>
			</el-pagination>
		</div>
		<import-tips
			:show="importOpen"
			:data="importData"
			:succeedNumber="importSucceedNumber"
			:errorNumber="importErrorNumber"
			@importOpnes="importOpnes"
		/>
	</div>
</template>

<script>
import importTips from "./importTips.vue";
import {
	importDateDownloadTemplate,
	projectManagementGet,
	capitalizationManagementQueryAll,
	capitalizationManagementQuery,
	capitalizationManagementSave,
	capitalizationManagementDelete
} from "../index";

export default {
	components: {
		importTips
	},
	props: {
		projectId: {
			type: String,
			default: ""
		},
		type: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			upload: {
				// 是否显示弹出层
				open: false,
				// 是否禁用上传
				isUploading: false,
				// 上传的地址
				url:
						this.mainBaseURL +
					"/capitalizationManagement/importCapitalizationManagements"
			},
			importOpen: false,
			importData: [],
			importSucceedNumber: 0,
			importErrorNumber: 0,
			centerDialogVisible: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10
			},
			datas: [],
			total: 1,
			formData: {},
			rules: {
				annual: [{ required: true, message: "请选择年", trigger: "change" }],
				intangibleAssetName: [
					{ required: true, message: "请输入无形资产名称", trigger: "blur" }
				],
				amortizationTotal: [
					{ required: true, message: "请输入总摊销额", trigger: "blur" }
				],
				amortizationDuration: [
					{ required: true, message: "请输入摊销时长", trigger: "blur" },
                    {pattern: /^[0-9]+$/, message: "请输入正整数", trigger: "blur"}
				]
			},
			amortizationTotal: "",
			projectList: [],
			// 遮罩层
			loading: true
		};
	},
	created() {
		this.resetQuery();
	},
	methods: {
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		/** 列表 */
		getList() {
			this.loading = true;
			capitalizationManagementQueryAll(this.queryParams).then(res => {
				if (res.code == "00000") {
					this.datas = res.data.records;
					this.total = res.data.total;
				}
				this.loading = false;
			});
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = 10;
			this.getList();
		},
		/** 重置按钮操作 */
		resetQuery() {
			this.resetForm("formQuery");
			this.queryParams = {};
			if (this.type) {
				this.queryParams.projectId = this.projectId;
			}
			this.handleQuery();
		},
		// 表单重置
		reseForm() {
			this.formData = {};
			if (!this.type) {
				projectManagementGet().then(res => {
					this.projectList = res.data;
				});
			} else {
				this.formData.projectId = this.projectId;
			}
			this.resetForm("formData");
		},
		// 新增
		handleAdd() {
			this.reseForm();
			this.centerDialogVisible = true;
		},
		handleUpdate(id) {
			this.reseForm();
			capitalizationManagementQuery(id).then(res => {
				this.formData = res.data;
				this.amortizationTotal =
					Number(this.formData.amortizationTotal) /
					Number(this.formData.amortizationDuration);
				this.centerDialogVisible = true;
			});
		},
		classSubmitForm() {
			this.$refs["formData"].validate(valid => {
				if (valid) {
					capitalizationManagementSave(this.formData).then(res => {
						if (res.code === "00000") {
							this.handleQuery();
							this.centerDialogVisible = false;
							this.msgSuccess(res.msg);
						}
					});
				} else {
					return false;
				}
			});
		},
		handleDelete(id) {
			this.$confirm("是否确认删除资本化?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(function() {
					return capitalizationManagementDelete({ ids: [id] });
				})
				.then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				})
				.catch(function() {});
		},
		ntxe() {
			if (
				this.formData.amortizationTotal != undefined &&
				this.formData.amortizationDuration != undefined &&
				this.formData.amortizationTotal != "" &&
				this.formData.amortizationDuration != ""
			) {
				this.amortizationTotal =
					Number(this.formData.amortizationTotal) /
					Number(this.formData.amortizationDuration);
			}
		},
		importTemplate() {
			importDateDownloadTemplate(3).then(res => {
				if (res.code == "00000") {
					window.open(res.data, "_blank");
				}
			});
		},
		handleFileProgress(event, file, fileList) {
			this.upload.isUploading = true;
		},
		handleFileSuccess(response, file, fileList) {
			if (response.code == "00000") {
				this.upload.open = false;
				this.upload.isUploading = false;
				this.$refs.upload.clearFiles();
				this.importOpen = true;
				this.importData = response.data.errorList;
				this.importSucceedNumber = response.data.succeedNumber;
				this.importErrorNumber = response.data.errorNumber;
				this.getList();
			} else {
				this.upload.isUploading = false;
				this.$refs.upload.abort();
				this.$message.error(response.msg);
			}
		},
		submitFileForm() {
			this.$refs.upload.submit();
		},
		handleFileExceed(response) {
			this.$alert("只能上传一个文件");
		},
		importOpnes() {
			this.importOpen = false;
			this.importData = [];
			this.importSucceedNumber = 0;
			this.importErrorNumber = 0;
		}
	}
};
</script>
<style scoped>
.from {
	margin-top: 15px;
}
.item_btn {
	float: right;
}
</style>
